import { render, staticRenderFns } from "./DocumentCodeForm.vue?vue&type=template&id=31215538&scoped=true"
import script from "./DocumentCodeForm.vue?vue&type=script&lang=js"
export * from "./DocumentCodeForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentCodeForm.vue?vue&type=style&index=0&id=31215538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31215538",
  null
  
)

export default component.exports